import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import HighSchoolTranscriptTypeService from "../../../Services/HighSchoolTranscriptType.service";
import HighSchoolTranscriptTypeLookupModal from "./HighSchoolTranscriptTypeLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => HighSchoolTranscriptTypeService.search({
        ids: options === null || options === void 0 ? void 0 : options.ids,
        query: search || (options === null || options === void 0 ? void 0 : options.query),
        names: options === null || options === void 0 ? void 0 : options.names,
        srcSystemIds: options === null || options === void 0 ? void 0 : options.srcSystemIds,
    }, { max: 20 }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const HighSchoolTranscriptTypeSearch = makeSearch(makeSearchArgs);
export const HighSchoolTranscriptTypeMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error - TS2322 - Type 'ComponentType<WithModalParams<LookupModalProps<HighSchoolTranscriptType, any>>>' is not assignable to type 'ComponentType<never> | undefined'.
    lookupModal: HighSchoolTranscriptTypeLookupModal }));
